const init = {}

const loginReducer = (state = init, action) => {

    switch (action.type) {

        default: return state
    }
}

export default loginReducer